'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$IBAN$() {
  this.aEI = null;
  this.aEJ = false;
}
export { $c_Lapp_data_PaymentDetails$package$IBAN$ as $c_Lapp_data_PaymentDetails$package$IBAN$ };
$p = $c_Lapp_data_PaymentDetails$package$IBAN$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_PaymentDetails$package$IBAN$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$IBAN$() {
}
export { $h_Lapp_data_PaymentDetails$package$IBAN$ as $h_Lapp_data_PaymentDetails$package$IBAN$ };
$h_Lapp_data_PaymentDetails$package$IBAN$.prototype = $p;
$p.aA = (function() {
  if ((!this.aEJ)) {
    this.aEI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aEJ = true;
  }
  return this.aEI;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_PaymentDetails$package$IBAN$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$IBAN$, "app.data.PaymentDetails$package$IBAN$", ({
  EG: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_PaymentDetails$package$IBAN$ as $d_Lapp_data_PaymentDetails$package$IBAN$ };
var $n_Lapp_data_PaymentDetails$package$IBAN$;
function $m_Lapp_data_PaymentDetails$package$IBAN$() {
  if ((!$n_Lapp_data_PaymentDetails$package$IBAN$)) {
    $n_Lapp_data_PaymentDetails$package$IBAN$ = new $c_Lapp_data_PaymentDetails$package$IBAN$();
  }
  return $n_Lapp_data_PaymentDetails$package$IBAN$;
}
export { $m_Lapp_data_PaymentDetails$package$IBAN$ as $m_Lapp_data_PaymentDetails$package$IBAN$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-I-B-A-N$.js.map
